import { apiGet, createApiUrl } from '@/utils/apiUtils'
import type { MeResponse } from '@server/types/responseTypes'

export const fetchAuthedUser = async () => {
  const res = await apiGet<MeResponse>(createApiUrl('me'))
  return res.data
}
